import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { EventsService } from '../../events/shared/events.service';
import { EventRead } from '../../events/shared/event-read.model';
import { PagedResult } from '../../shared/model/generic-paged-result.model';

@Component({
  selector: 'wl-dashboard-neo-events',
  templateUrl: 'dashboard-neo-events.component.html',
  styleUrls: ['dashboard-neo-events.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardNeoEventsComponent implements OnInit {
  private _eventsService: EventsService;

  public eventsList: PagedResult<EventRead[]>;
  public totalEventCount: number;
  public showExpandedEventList: boolean;
  public isLoading: boolean;

  public constructor(eventsService: EventsService) {
    this._eventsService = eventsService;
    this.isLoading = true;

    this.eventsList = new PagedResult<EventRead[]>();
  }

  ngOnInit() {
    this.showExpandedEventList = false;

    this.loadEvents(1);
  }

  public loadEvents(pageNum: number): void {
    this._eventsService.getUpcomingOrgEventsForSixMonthsPaged(7, pageNum).then((data: PagedResult<any>) => {
      this.eventsList = data;
      this.totalEventCount = data.TotalCount;
      this.isLoading = false;
    });
  }

  public onPagingEvent(page: number) {
    this.loadEvents(page);
  }
}
